import React from "react";
import "./how.scss";
const How = () => {
  return (
    <>
      <section className="howmain" id="how">
        <img
          src="/assets/howassets/howtopshade.png"
          alt="howtopshade"
          className="howtopshade"
        />
            {window.innerWidth < 991 ? 
        <img
          src="/assets/howassets/howbottomshadembl.png"
          alt="howbottomshade"
          className="howbottomshade"
        />
        :
             <img
          src="/assets/howassets/howbottomshade.png"
          alt="howbottomshade"
          className="howbottomshade"
        />
            }
        <div className="custom-container">
          <div className="howinner">
            <div className="howleft">
              <span className="howspan">How It Works</span>
              <h4 className="howhead">Our Verifiable Randomness Engine</h4>
            </div>
            <div className="howright">
              <div className="howcard">
                <div className="cardleft">
                  <img
                    src="/assets/howassets/howone.svg"
                    alt="cardimg"
                    className="cardimg"
                  />
                  <span className="cardline"></span>
                </div>
                <div className="cardright">
                  <h6 className="righthead">User Requests Random Outcome</h6>
                  <p className="rightpara">
                    Smart contract calls Chainlink VRF.
                  </p>
                </div>
              </div>
              <div className="howcard">
                <div className="cardleft">
                  <img
                    src="/assets/howassets/howtwo.svg"
                    alt="cardimg"
                    className="cardimg"
                  />
                  <span className="cardline"></span>
                </div>
                <div className="cardright">
                  <h6 className="righthead">Cryptographic Randomness</h6>
                  <p className="rightpara">VRF returns a result with proof.</p>
                </div>
              </div>
              <div className="howcard">
                <div className="cardleft">
                  <img
                    src="/assets/howassets/howthree.svg"
                    alt="cardimg"
                    className="cardimg"
                  />
                  <span className="cardline"></span>
                </div>
                <div className="cardright">
                  <h6 className="righthead">Smart Contract Verifies</h6>
                  <p className="rightpara">Ensures fairness on-chain.</p>
                </div>
              </div>
              <div className="howcard">
                <div className="cardleft">
                  <img
                    src="/assets/howassets/howfour.svg"
                    alt="cardimg"
                    className="cardimg"
                  />
                  <span className="cardline"></span>
                </div>
                <div className="cardright">
                  <h6 className="righthead">Price Entropy Added </h6>
                  <p className="rightpara">
                    Uses LUCK/BNB price to anchor randomness.
                  </p>
                </div>
              </div>
              <div className="howcard">
                <div className="cardleft">
                  <img
                    src="/assets/howassets/howfive.svg"
                    alt="cardimg"
                    className="cardimg"
                  />
                </div>
                <div className="cardright">
                  <h6 className="righthead">Final Result Applied</h6>
                  <p className="rightpara">
                    Determines win/loss, loot, or outcomes.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default How;
